import {
  Currency,
  Ga4Object,
  Item,
  ItemCategory,
  ProductEntryPoint,
} from "@types-runway/analytics";

// Every line item leaves the app as the same non-clinical shape. The internal
// Item keeps the product id and name for cart logic; neither reaches the data
// layer. The only thing that tells lines apart is the category: "product" for an
// Rx or OTC item, "service" for the consultation visit fee.
// Contract: operations-hub/docs/data-layer-contract.md §3.
const ITEM_NAME = "Product";
const ITEM_BRAND = "Runway";

// quantity is always 1: price is the line total, and the ad platforms multiply
// price by quantity.
type Ga4Item = {
  item_name: typeof ITEM_NAME;
  item_brand: typeof ITEM_BRAND;
  item_category: ItemCategory;
  price: number;
  quantity: 1;
  currency: Currency;
  product_entry_point: ProductEntryPoint;
};

export class Ga4DTO {
  public currency?: string;
  public value?: number;
  public addon_value?: number;
  public coupon?: string | null;
  public transaction_id?: string;
  public items?: Ga4Item[];
  public method?: string;

  constructor(ga4object: Ga4Object) {
    this.currency = ga4object.currency;
    this.value = ga4object.value;
    this.addon_value = ga4object.addonValue;
    this.coupon = ga4object.coupon;
    if (ga4object.transactionId) this.transaction_id = ga4object.transactionId;
    this.items = ga4object.items?.map((item: Item) => {
      return {
        item_name: ITEM_NAME,
        item_brand: ITEM_BRAND,
        item_category: item.category,
        price: item.price,
        quantity: 1,
        currency: item.currency,
        product_entry_point: item.productEntryPoint,
      };
    });
    this.method = ga4object.method;
  }
}
